import React from 'react';
import { useTranslation } from 'react-i18next';

const ShipmentDetailModal = ({ show, selectedShipment, modalLoading, modalError, onClose }) => {
  const { t, i18n } = useTranslation();

  if (!show || !selectedShipment) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-4">
      <div
        className="rounded-xl shadow-xl text-white p-6 relative w-full max-w-md max-h-[90vh] overflow-y-auto hide-scrollbar"
        style={{
          background: "radial-gradient(50% 49.29% at 50% 50%, #1D2461 0%, #080c25 100%)",
        }}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-4 text-2xl font-bold"
          aria-label={t('alt.closeModal')}
        >
          ×
        </button>

        {modalLoading && <div>{t('dashboard.loading')}</div>}
        {modalError && <div>{t('errors.error', { message: modalError })}</div>}

        {!modalLoading && !modalError && (
          <form className="space-y-4">
            <h3 className="text-sm text-cyan-500 font-semibold mt-4">{t('dashboard.shipmentOverview')}</h3>

            {[
              { label: t('orders.containerId'), value: selectedShipment.id },
              { label: t('orders.poNumber'), value: selectedShipment.order },
              { label: t('dashboard.customerName'), value: selectedShipment.customerName },
              { label: t('dashboard.numberOfPallets'), value: selectedShipment.noOfPallets },
              {
                label: t('orders.goodsType'),
                value: t(`orders.goodsTypeOptions.${selectedShipment.goodsType}`, { defaultValue: selectedShipment.goodsType }),
              },
              {
                label: t('dashboard.addedOn'),
                value: new Date(selectedShipment.addOnDate).toLocaleDateString(i18n.language),
              },
              {
                label: t('dashboard.currentStatus'),
                value: t(`dashboard.status.${selectedShipment.status.toLowerCase()}`, { defaultValue: selectedShipment.status }),
              },
            ].map(({ label, value }, i) => (
              <div key={i}>
                <label className="text-sm block mb-1">{label}</label>
                <input className="w-full px-3 py-1 rounded bg-gray-100 text-gray-900" value={value} readOnly />
              </div>
            ))}

            <div>
              <label className="text-sm block mb-1">{t('dashboard.stopsList')}</label>
              <textarea
                rows="3"
                className="w-full px-3 py-2 rounded bg-gray-100 text-gray-900 text-sm"
                value={
                  selectedShipment.intermediateDestinations
                    ?.map(stop => `${stop.destination} - ${new Date(stop.time).toLocaleString(i18n.language)}`)
                    .join('\n') || t('dashboard.noStops')
                }
                readOnly
              />
            </div>

            <div>
              <label className="text-sm block mb-1">{t('dashboard.statusUpdates')}</label>
              <textarea
                rows="3"
                className="w-full px-3 py-2 rounded bg-gray-100 text-gray-900 text-sm"
                value={selectedShipment.routeNotes || t('dashboard.noUpdates')}
                readOnly
              />
            </div>

            <h3 className="text-sm text-cyan-500 font-semibold mt-4">{t('dashboard.driverAssignmentControl')}</h3>

            <div>
              <label className="text-sm block mb-1">{t('dashboard.assignedDriver')}</label>
              <input
                className="w-full px-3 py-1 rounded bg-gray-100 text-gray-900"
                value={selectedShipment.driverName}
                readOnly
              />
            </div>

            {selectedShipment.driverDetails && (
              <>
                {[
                  { label: t('dashboard.driverEmail'), value: selectedShipment.driverDetails.email || 'N/A' },
                  { label: t('dashboard.driverPhone'), value: selectedShipment.driverDetails.mobileNumber || 'N/A' },
                  { label: t('dashboard.driverAddress'), value: selectedShipment.driverDetails.address || 'N/A' },
                ].map(({ label, value }, i) => (
                  <div key={i}>
                    <label className="text-sm block mb-1">{label}</label>
                    <input className="w-full px-3 py-1 rounded bg-gray-100 text-gray-900" value={value} readOnly />
                  </div>
                ))}
              </>
            )}

            <div>
              <label className="text-sm block mb-1">{t('dashboard.vehicleNumber')}</label>
              <input
                className="w-full px-3 py-1 rounded bg-gray-100 text-gray-900"
                value={selectedShipment.vehicleNumber || 'N/A'}
                readOnly
              />
            </div>

            <div>
              <label className="text-sm block mb-1">{t('orders.goodsType')}</label>
              <input
                className="w-full px-3 py-1 rounded bg-gray-100 text-gray-900"
                value={t(`orders.goodsTypeOptions.${selectedShipment.goodsType}`, { defaultValue: selectedShipment.goodsType })}
                readOnly
              />
            </div>

            <div>
              <label className="text-sm block mb-1">{t('dashboard.routeNotes')}</label>
              <textarea
                rows="3"
                className="w-full px-3 py-2 rounded bg-gray-100 text-gray-900 text-sm"
                value={selectedShipment.routeNotes || t('dashboard.noNotes')}
                readOnly
              />
            </div>

            <div className="mt-6 flex gap-4 justify-center">
              <button
                onClick={onClose}
                className="bg-[#00B69B] text-white py-2 px-4 rounded-md font-semibold text-sm"
                aria-label={t('alt.close')}
              >
                {t('Close')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ShipmentDetailModal;